import clsx from "clsx"
import React, { useEffect, useState } from "react"
import { FaChevronDown, FaChevronUp } from "react-icons/fa"

import { RegularButton } from "@components/button"
import { CourseHeading } from "."

interface ClassDescriptionProps {
  description: string
}

export const CourseDescription: React.FC<ClassDescriptionProps> = ({ description }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [hasToggler, setHasToggler] = useState(false)

  useEffect(() => {
    const getData = () => {
      const desc = document.getElementById("class-desc")

      if (desc) {
        const height = desc.getBoundingClientRect().height

        if (height >= 144) {
          setHasToggler(true)
        }
      }
    }

    getData()
  }, [description])

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <section className={clsx("bg-[#F7F7F7] sm:p-9 p-4 rounded")} id="desc-id">
      <CourseHeading customMargin="sm:mb-6 mb-4">Deskripsi Course</CourseHeading>
      <div
        id="class-desc"
        className={clsx(
          !isOpen && "max-h-[9rem] overflow-hidden",
          "sm:leading-6 leading-5 sm-only:text-sm"
        )}
      >
        {description}
      </div>

      {hasToggler && (
        <div className="pt-5">
          {!isOpen ? (
            <RegularButton
              onClick={handleClick}
              textClassName="flex items-center"
              variant="transparent"
              className="w-full !bg-transparent"
            >
              Lihat Selengkapnya <FaChevronDown className="ml-3" />
            </RegularButton>
          ) : (
            <RegularButton
              onClick={handleClick}
              textClassName="flex items-center"
              variant="transparent"
              className="w-full !bg-transparent"
            >
              Lihat Lebih Sedikit <FaChevronUp className="ml-3" />{" "}
            </RegularButton>
          )}
        </div>
      )}
    </section>
  )
}
